import { K as KEYBOARD_KEYNAMES } from '../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-AmBipDtf-AmBipDtf.js';

const handleKeyDownEvents = (event, escapeAction) => {
  const {
    key
  } = event;
  if (key === KEYBOARD_KEYNAMES.ESCAPE) {
    escapeAction();
    event.preventDefault();
  }
};

/**
 * @TODO: make this prop
 * https://sim.amazon.com/issues/CFX-2706
 * https://sim.amazon.com/issues/CFX-3296
 * (https://react.dev/reference/react/Children#accepting-an-array-of-objects-as-a-prop)
 */
const defaultValueSerializer = value => {
  try {
    if (value === null) {
      return value;
    }
    if (typeof value === 'undefined') {
      return value;
    }
    if (typeof value === 'number') {
      return value;
    }
    if (typeof value === 'string') {
      return value;
    }
    return JSON.stringify(value);
  } catch (error) {
    return value;
  }
};
const getPlacement = position => {
  if (position === 'top') {
    return 'top-start';
  }
  return 'bottom-start';
};

export { defaultValueSerializer as d, getPlacement as g, handleKeyDownEvents as h };
//# sourceMappingURL=utils-CQt-4mmE.js.map
